export default __webpack_public_path__ + "static/media/rpgmaker.a0a3b451.png";